import { render, staticRenderFns } from "./ToggleReviewQuestionForm.vue?vue&type=template&id=168a88db&scoped=true"
import script from "./ToggleReviewQuestionForm.vue?vue&type=script&lang=js"
export * from "./ToggleReviewQuestionForm.vue?vue&type=script&lang=js"
import style0 from "./ToggleReviewQuestionForm.vue?vue&type=style&index=0&id=168a88db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a88db",
  null
  
)

export default component.exports